import React from "react"
import { VFC } from "react"

type Props = {
  parameters: string 
}

const Map: VFC<Props> = ({ parameters }) => {

  return (
    <div className="mt-16 h-96 md:mt-20">
      <iframe className="w-full h-full" src={(`https://www.google.com/maps/embed?${parameters}`)}></iframe>
    </div>
  )
}

export default Map
